<template>
  <div
    v-bind:style="style"
    class="additional-fixed-tabs"
    :class="[additionalFixedTabsClass]"
    v-if="tabs.length && tabs.some(tab => tab.show)"
  >
    <ul
      class="additional-fixed-tabs__list"
    >
      <li
        v-for="tab in tabs"
        v-if="tab.show"
        class="additional-fixed-tabs__item"
        :class="{active: $route.path.includes(`agenda/sessions`) && agendaRoute === tab.to}"
      >
        <router-link :to="tab.to">{{ tab.name }}</router-link>
        <span class="additional-fixed-tabs__notify" v-if="tab.count">{{ tab.count }}</span>
      </li>
    </ul>

  </div>
</template>

<script>
import {ROUTES} from "../../../router";

export default {
  props: [
    'tabs',
    'style',
    'additionalFixedTabsClass'
  ],
  data() {
    return {
      agendaRoute: ROUTES.AGENDA_EVENT.replace(':attendeeId', this.$route.params.attendeeId)
    }
  }
}
</script>

<style  lang="scss">


.additional-fixed-tabs {
  width: auto;
  display: flex;
  align-items: center;
  background-color: white;
  height: var(--attendee-header-height);
  z-index: 22;

  @media (max-width: 1100px) {
   justify-content: space-between;
  }

  @media (max-width: 900px) {
    padding: 0 var(--attendee-gap-md);
    position: sticky;
    top: calc(var(--attendee-header-height) + 1px);
    width: 100%;
  }


  //@media (max-width: 430px) {
    //padding: 0 var(--attendee-gap-sm);

  //}


  //&.noVisibleItems {
  //  .additional-fixed-tabs__list {
  //    display: none;
  //  }
  //
  //  .button-filter-mobile {
  //
  //  }
  //
  //  // phone
  //  @media (max-width: 900px) {
  //    grid-template-columns: 30px 30px;
  //    justify-content: flex-end;
  //  }
  //
  //  // desktop
  //  @media (min-width: 1101px) {
  //    height: 0;
  //    border-bottom: none;
  //  }
  //}



  @media (max-width: 900px) {
    display: flex;
    justify-items: center;
    height: 60px;
    top: var(--attendee-header-mobile-height);
    border-bottom: 0;
  }

  @media (max-width: 400px) {
    //grid-template-columns: 0 1fr 30px;
    gap: 5px;
  }

  &__empty{

  }

  &__notify {
    background-color: rgb(255, 102, 102);
    font-size: 12px;
    color: white;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -7px;
    right: -7px;
    position: absolute;
    z-index: 2;
    min-width: 15px;
    border-radius: 15px;
    padding: 0 4px;
  }

  &__list {
    display: flex;
    align-items: center;
    border: 1px solid var(--attendee-brand-color);
    border-radius: var(--attendee-card-border-radius);
    height: 32px;
    overflow: visible;
    margin-bottom: 0;

    @media (max-width: 900px) {
      width: 100%;
    }
  }

  &__item {
    position: relative;
    border-right: 1px solid var(--attendee-brand-color);
    height: 100%;
    flex: 1 1 100%;

    @media (max-width: 900px) {
      text-align: center;
    }

    &:first-child{

      a {
        border-top-left-radius: calc(var(--attendee-card-border-radius) - 1px);
        border-bottom-left-radius:  calc(var(--attendee-card-border-radius) - 1px);
      }
    }


    &:last-child {
      border-right: none;


      a{
        border-top-right-radius: calc(var(--attendee-card-border-radius) - 1px);
        border-bottom-right-radius: calc(var(--attendee-card-border-radius) - 1px);
      }
    }

    &.active {
      a {

        color: white;
        background-color: var(--attendee-brand-color);
      }
    }

    a {
      padding: 0 var(--attendee-gap-lg);
      transition: .3s all;
      white-space: nowrap;
      text-decoration: none;
      line-height: 29px;
      font-weight: 400;
      color: var(--attendee-text-primary-color);
      font-size: 19px;
      display: block;
      height: 100%;


      @media (max-width: 900px) {
        padding: 0 var(--attendee-gap-md);
        font-size: 17px;
      }

      &.router-link-exact-active {
        color: white;
        background-color: var(--attendee-brand-color);
      }
    }
  }
}
</style>
